<template lang="html">
  <div class="banner">
    <div class="info m-3">
      <h4 class="title">Ofereça um parcelamento pelo BoletoFlex</h4>
    </div>
    <button-component label="INICIAR FINANCIAMENTO" class="btn-green m-3" :to="{name: 'CreateTransaction'}" />
  </div>
</template>

<script>
import Button from '../../button/Button.vue'
export default {
  components: {
    'button-component': Button
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variaveis.scss";
@import "src/assets/scss/mixins.scss";
  .banner {
    display: flex;
    flex-direction: row;
    border-radius: 4px;
    overflow: hidden;
    color: #444;
    cursor: pointer;
    z-index: 0;
    align-items: center;
    justify-content: space-between;
    & > * {
      position: relative;
      z-index: 1;
    }
    .thumb {
      height: 100px;
    }
    .info {
      .title {
        margin-bottom: 0;
        font-size: 20px;
      }
    }
    @include media-breakpoint-down(md) {
    }
    @include media-breakpoint-down(sm) {
      .info {
        margin-bottom: 0;
      }
      flex-direction: column;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/cards/banner/Banner.vue